<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'typeEntite1'" [isTitleHidden]="true" (load)="loaded()"></custom-frame>
